import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// import Home from '@/views/Home.vue'; // @ is an alias to /src
let App = class App extends Vue {
    constructor() {
        super();
        this.snackbar = new CBcSnackbar();
        const that = this;
    }
    async created() {
        const that = this;
        const isTest = /true/i.test(((await that.axios.get('/api/config/server/istestenv') || {}).data || {}).result);
        console.log('is test set:', isTest);
        that.setSrvCfgTestEnv(isTest);
    }
};
__decorate([
    Getter
], App.prototype, "sessionTimeout", void 0);
__decorate([
    Mutation
], App.prototype, "setSessionTimeout", void 0);
__decorate([
    Mutation
], App.prototype, "setSrvCfgTestEnv", void 0);
App = __decorate([
    Component({
        // data: () => ({
        // }),
        // props: {
        //   source: String,
        // },
        components: {
            BcSnackbar,
        },
        // methods: {
        // },
        watch: {
            $route(to, form) {
                const that = this;
                if (to.name === 'login' && that.sessionTimeout) {
                    that.snackbar.error('登陆已过期，请重新登陆');
                    // @ts-ignore
                    that.setSessionTimeout(false);
                }
            },
        }
    })
], App);
export default App;
